export const INTENT_BUSINESS = 'business';
export const INTENT_GROUP = 'groups';
export const INTENT_MYSELF = 'myself';
export const INTENT_FUNDRAISING = 'fundraising';
